export const WarningContainerDefProps = {
  title: "Warning Container"
};